import React, { useEffect } from 'react';

import { useCheckoutContext } from 'Jsx/CheckoutV4/Context';

import I18N_STRINGS from 'Jsx/CheckoutV4/i18n/language';

import InputField, { ChangeState } from './InputField';

export interface EmailState {
  email: string;
  isValid: boolean;
}

interface EmailInputProps {
  onEmailChange: ({ email, isValid }: EmailState) => void;
}

const EmailInput = ({ onEmailChange }: EmailInputProps) => {
  const { isGuestCheckout, user } = useCheckoutContext();
  const { EMAIL_LABEL } = I18N_STRINGS;

  const onChange = ({ value, isValid }: ChangeState) => {
    onEmailChange({ email: value, isValid });
  };

  useEffect(() => {
    if (!isGuestCheckout && user) {
      const { email } = user;

      if (email) onEmailChange({ email, isValid: true });
      else onEmailChange({ email: '', isValid: false });
    }
  }, [isGuestCheckout, user]);

  return isGuestCheckout || (!isGuestCheckout && !user) ? (
    <InputField
      type="email"
      onChange={onChange}
      label={EMAIL_LABEL}
      className="mb-24"
      id="userEmail"
      name="userEmail"
      testId="email-field"
    />
  ) : null;
};

export default EmailInput;
